module.exports = __webpack_public_path__ + "img/pro-xtIcon8.02e1bd15.png";